import { Component, computed, inject, signal } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { COMMON_IMPORTS } from '../../../../../../Shared/common-imports';
import { LicenceQuantityDialogData } from '../../../../../Interfaces/licence-quantity-dialog.interface';
import { LICENCE_COMPONENT_LABEL_KEYS, MIN_LICENCE_QUANTITY } from '../../../../../../../Consts/licences.const';

@Component({
    selector: 'app-licence-quantity-dialog',
    standalone: true,
    imports: [COMMON_IMPORTS],
    templateUrl: './licence-quantity-dialog.component.html',
    styleUrls: ['../../../billing/billing.scss'],
})
export class LicenceQuantityDialogComponent {
    readonly data = inject<LicenceQuantityDialogData>(MAT_DIALOG_DATA);
    private readonly _dialogRef = inject(MatDialogRef<LicenceQuantityDialogComponent, number>);

    readonly quantity = signal<number>(MIN_LICENCE_QUANTITY);

    readonly minQuantity = MIN_LICENCE_QUANTITY;

    readonly isCancelMode = computed<boolean>(() => this.data.mode === 'cancel');

    readonly maxQuantity = computed<number | null>(() =>
        this.isCancelMode() ? this.data.component.cancellable : null,
    );

    readonly componentLabelKey = computed<string>(
        () => LICENCE_COMPONENT_LABEL_KEYS[this.data.component.component_type],
    );

    readonly titleKey = computed<string>(() =>
        this.isCancelMode() ? 'app.billing.licences.cancel.title' : 'app.billing.licences.buy.title',
    );

    readonly confirmKey = computed<string>(() =>
        this.isCancelMode() ? 'app.billing.licences.cancel.confirm' : 'app.billing.licences.buy.confirm',
    );

    readonly maxParams = computed<Record<string, number>>(() => ({ max: this.maxQuantity() ?? 0 }));

    readonly isConfirmDisabled = computed<boolean>(() => {
        const quantity = this.quantity();
        const max = this.maxQuantity();

        if (!Number.isInteger(quantity) || quantity < MIN_LICENCE_QUANTITY) {
            return true;
        }

        return max !== null && quantity > max;
    });

    setQuantity(value: string): void {
        this.quantity.set(Number.parseInt(value, 10));
    }

    confirm(): void {
        if (this.isConfirmDisabled()) {
            return;
        }

        this._dialogRef.close(this.quantity());
    }

    close(): void {
        this._dialogRef.close();
    }
}
